import logo from './logo.svg';
import './App.css';
import MainNavigator from './CVNavigator/MainNavigator';
import ThemeToggle from './Components/ThemeToggle';

function App() {
  return (
    <>
      <MainNavigator />
      <ThemeToggle />
    </>
  );
}

export default App;
